import { forwardRef, TextareaHTMLAttributes } from "react";
import styles from "./FormField.module.css";
import { Form } from "react-bootstrap";
import cn from "classnames";
import { IFieldTheme } from "./FormField";

interface IFormTextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  showError?: boolean;
  errorText?: string;
  disabled?: boolean;
  fieldTheme?: IFieldTheme;
  className?: string;
}

const FormTextarea = forwardRef<HTMLTextAreaElement, IFormTextareaProps>(
  (props, ref) => {
    const {
      fieldTheme = IFieldTheme.DEFAULT,
      label,
      showError,
      errorText,
      disabled,
      className,
      ...restProps
    } = props;

    return (
      <div className={cn(styles.formField, className, styles[fieldTheme])}>
        {label && <Form.Label className={styles.label}>{label}</Form.Label>}

        <textarea
          ref={ref}
          disabled={disabled}
          className={cn('form-control', styles.formControl, disabled && styles.disabled)}
          {...restProps}
        />

        {showError && <div className={styles.errorText}>{errorText}</div>}
      </div>
    );
  }
);

export default FormTextarea;